<template>
  <div data-v-f0fe0ef4="" data-v-e5781868="" class="topicTopBar" style="display: flex">
    <div data-v-f0fe0ef4="" class="bar">
      <div data-v-f0fe0ef4="" class="navLeft">
        <a href="javascript:void(0);" @click="$router.go(-1)"
          ><svg data-v-338e1447="" data-v-f0fe0ef4="" aria-hidden="true" class="svg-icon navback">
            <use data-v-338e1447="" xlink:href="#icon-navback"></use></svg></a
        ><a href="javascript:void(0);" @click="$parent.goNav('/')">
          <img style="width: 1.9rem; height: 1rem; display: block" v-if="$store.state.appInfo.site_logo" :src="$store.state.appInfo.site_logo" alt="" />

          <svg data-v-338e1447="" v-else data-v-f0fe0ef4="" aria-hidden="true" class="svg-icon navlogo">
            <use data-v-338e1447="" xlink:href="#icon-navlogo"></use>
          </svg> </a
        ><img data-v-f0fe0ef4="" src="/static/style/top-pc-img2.fb72c9c3.png" alt="" />
      </div>
      <div data-v-5a0919b8="" data-v-f0fe0ef4="" class="header">
        <div data-v-5a0919b8="" class="topNav">
          <div data-v-5a0919b8="" class="notifications">
            <div data-v-5a0919b8="" class="bell">
              <svg data-v-338e1447="" data-v-5a0919b8="" aria-hidden="true" class="svg-icon iconBell">
                <use data-v-338e1447="" xlink:href="#icon-iconBell"></use>
              </svg>
              <span data-v-5a0919b8="" v-if="$store.state.messageNum" class="num">{{ $store.state.messageNum }}</span>
              <div data-v-5a0919b8="" class="subnav msg-subnav">
                <div data-v-5a0919b8="" class="messages havemsg">
                  <div data-v-5a0919b8="" class="msg-list">
                    <ul data-v-5a0919b8="">
                      <!-- <li data-v-5a0919b8="">
														<div data-v-5a0919b8="" class="title"><i data-v-5a0919b8=""></i>恭喜成为{{$store.state.appInfo.title}}会员 </div>
														<p data-v-5a0919b8="" class="content">恭喜您成为{{$store.state.appInfo.title}}大家庭的成员，诚邀参与新人专享三重礼，存款即享火速到账，最高返还40%，金额无上限，史无前例专属特惠！</p>
														<div data-v-5a0919b8="" class="bottom"><span data-v-5a0919b8="">2022-03-04 20:58:16</span></div>
													</li>
													<li data-v-5a0919b8="">
														<div data-v-5a0919b8="" class="title">网站新增备用网址：k8554.com、k8357.com </div>
														<p data-v-5a0919b8="" class="content">网站新增备用网址：k8554.com、k8357.com</p>
														<div data-v-5a0919b8="" class="bottom"><span data-v-5a0919b8="">2021-12-01 11:24:28</span></div>
													</li> -->
                      <li data-v-5a0919b8="" v-for="(item, index) in noticeList" :key="index">
                        <div data-v-5a0919b8="" class="title"><i data-v-5a0919b8=""></i>{{ item.title }}</div>
                        <p data-v-5a0919b8="" class="content" v-html="item.content"></p>
                        <div data-v-5a0919b8="" class="bottom">
                          <span data-v-5a0919b8="">{{ item.created_at }}</span>
                        </div>
                      </li>
                      <li data-v-5a0919b8="">
                        <div data-v-5a0919b8="" class="more-button" @click="$parent.goNav('/messages')">更多消息</div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--未登录-->
          <div data-v-5a0919b8="" class="notLogin" v-if="!$store.state.token">
            <div data-v-5a0919b8="" class="demo">还不是会员？ <a data-v-5a0919b8="" @click="registerBox()">注册会员</a></div>
            <div data-v-5a0919b8="" class="userLogin">
              <a data-v-5a0919b8="" class="btn buttonBordered" @click="loginBox()"
                >登录
                <svg data-v-338e1447="" data-v-5a0919b8="" aria-hidden="true" class="svg-icon iconArrow">
                  <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg></a
              ><a data-v-5a0919b8="" class="btn buttonSolid animation" @click="registerBox()"
                >注册
                <svg data-v-338e1447="" data-v-5a0919b8="" aria-hidden="true" class="svg-icon iconArrow">
                  <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
              ></a>
            </div>
          </div>

          <!--已登录-->
          <div data-v-5a0919b8="" class="loggined" v-if="$store.state.token">
            <div data-v-5a0919b8="" class="userButtons">
              <a data-v-5a0919b8="" class="btn buttonSolid" href="javascript:void(0);" @click="$parent.goNav('/deposit')"
                ><svg data-v-338e1447="" data-v-5a0919b8="" aria-hidden="true" class="svg-icon iconDeposit icon">
                  <use data-v-338e1447="" xlink:href="#icon-iconDeposit"></use>
                </svg>
                存款
                <svg data-v-338e1447="" data-v-5a0919b8="" aria-hidden="true" class="svg-icon iconArrow">
                  <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg></a
              ><a data-v-5a0919b8="" class="btn buttonBordered" href="javascript:void(0);" @click="$parent.goNav('/withdraw')"
                ><svg data-v-338e1447="" data-v-5a0919b8="" aria-hidden="true" class="svg-icon iconWithdraw icon">
                  <use data-v-338e1447="" xlink:href="#icon-iconWithdraw"></use>
                </svg>
                取款
                <svg data-v-338e1447="" data-v-5a0919b8="" aria-hidden="true" class="svg-icon iconArrow">
                  <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
              ></a>
            </div>
            <div data-v-5a0919b8="" class="user" v-if="$store.state.userInfo.username">
              <div data-v-5a0919b8="" class="info">
                <div data-v-5a0919b8="" class="info__top">
                  <h4 data-v-5a0919b8="" class="user-name">{{ $store.state.userInfo.username ? $store.state.userInfo.username : '' }}<img style="height: 15px" @click="$parent.goNav('/vip')" :src="baseURL + $store.state.userInfo.vipname" alt="" /></h4>
                </div>
                <p data-v-5a0919b8="" class="balance">{{ $store.state.userInfo.balance }}<span data-v-5a0919b8="">元</span></p>
              </div>
              <div data-v-5a0919b8="" class="userImg">
                <img data-v-5a0919b8="" src="/static/image/user.f11fb639.png" />
                <div data-v-5a0919b8="" class="userNav">
                  <svg data-v-338e1447="" data-v-5a0919b8="" aria-hidden="true" class="svg-icon iconArrowTop">
                    <use data-v-338e1447="" xlink:href="#icon-iconArrowTop"></use></svg
                  ><a data-v-5a0919b8="" :class="$route.path == '/accountSetting' ? 'active' : ''" href="javascript:void(0);" @click="$parent.goNav('/accountSetting')"
                    ><svg data-v-338e1447="" data-v-5a0919b8="" aria-hidden="true" class="svg-icon iconSetting icon">
                      <use data-v-338e1447="" xlink:href="#icon-iconSetting"></use>
                    </svg>
                    账户设置 </a
                  ><a data-v-5a0919b8="" :class="$route.path == '/myWallet' ? 'active' : ''" href="javascript:void(0);" @click="$parent.goNav('/myWallet')"
                    ><svg data-v-338e1447="" data-v-5a0919b8="" aria-hidden="true" class="svg-icon iconWallet icon">
                      <use data-v-338e1447="" xlink:href="#icon-iconWallet"></use>
                    </svg>
                    我的钱包 </a
                  ><a data-v-5a0919b8="" :class="$route.path == '/fundingRecords' ? 'active' : ''" href="javascript:void(0);" @click="$parent.goNav('/fundingRecords')"
                    ><svg data-v-338e1447="" data-v-5a0919b8="" aria-hidden="true" class="svg-icon iconRecord icon">
                      <use data-v-338e1447="" xlink:href="#icon-iconRecord"></use>
                    </svg>
                    资金记录 </a
                  ><a data-v-5a0919b8="" class="row" @click="openT"
                    ><svg data-v-338e1447="" data-v-5a0919b8="" aria-hidden="true" class="svg-icon iconNewLogout icon">
                      <use data-v-338e1447="" xlink:href="#icon-iconNewLogout"></use></svg
                    >安全退出
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Header',
  data() {
    return { noticeList: [], baseURL: '' };
  },
  created() {
    let that = this;
    that.getDatalist(); //获取消息
    that.baseURL = sessionStorage.getItem('baseURL') || '';
  },
  methods: {
    openT() {
      $('.outLoginBox').fadeIn(300);
    },
    getDatalist() {
      let that = this;
      let page = that.page;
      that.$apiFun
        .post('/api/noticeList', { page })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.noticeList = res.data.data;
            localStorage.setItem('messageNum', res.data.data.length);
            that.$store.commit('changMessageNum');
          }
        })
        .catch(res => {});
    },
    //弹出登录框
    loginBox() {
      console.log($('.mask'));
      $('.mask').fadeOut(300);
      $('.mask.login').fadeIn(300);
    },
    //弹出注册框
    registerBox() {
      $('.mask').fadeOut(300);
      $('.mask.register').fadeIn(300);
    },
    //弹出忘记密码框
    forgetBox() {
      $('.mask').fadeOut(300);
      $('.mask.forget').fadeIn(300);
    },
  },
  mounted() {
    $('.mask .close').click(function () {
      $(this).parents('.mask').fadeOut(300);
    });
    //鼠标经过头像显示下拉菜单
    $('.user').hover(function () {
      $(this).find('.userImg .userNav').toggleClass('userNav--active');
    });
  },
  updated() {
    //鼠标经过头像显示下拉菜单
    $('.user').hover(function () {
      $(this).find('.userImg .userNav').toggleClass('userNav--active');
    });
  },
};
</script>
<style lang="scss" scoped>
// @import '../../../static/css/chunk-b7675268.a1b3941c.css';
</style>



// WEBPACK FOOTER //
// src/components/libs/Header2.vue